module.exports = __webpack_public_path__ + "static/media/Haley Kotnik.32c189a5.png";